import { render, staticRenderFns } from "./MenuConponents.vue?vue&type=template&id=2f3a8615&scoped=true&"
import script from "./MenuConponents.vue?vue&type=script&lang=js&"
export * from "./MenuConponents.vue?vue&type=script&lang=js&"
import style0 from "./MenuConponents.vue?vue&type=style&index=0&id=2f3a8615&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3a8615",
  null
  
)

export default component.exports